import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListEmployers(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    getAllowedRoles(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    register(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    deleteEmployer(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }
})()